import type { Dispatch } from 'redux';
import {
    createDataActionFactory,
    Feature,
    ThunkDispatch,
    DeletedPersonType,
} from '../../../shared';
import {
    softOrHardDeleteOperation,
    DeleteOperationType,
} from '../../dataLayer/ows/persona/softOrHardDeletePersonas';
import type { HardDeleteActionPayload } from '../../actions/user/deletedItems/hardDeleteActions';
import { refreshCurrentPersonaListData } from '../user/personaListActions';

export const hardDeleteCompletedAction = createDataActionFactory<
    HardDeleteActionPayload,
    Error & HardDeleteActionPayload
>(
    'HardDeleteCompletedAction',
    Feature.HardDelete,
    action => {
        return {
            itemsInvolved: action.payload.personas.length,
        };
    },
    action => {
        return {
            itemsInvolved: action.payload.personas.length,
        };
    }
);

export function handleHardDeleteError(
    dispatch: Dispatch,
    error: Error,
    actionPayload: HardDeleteActionPayload
): void {
    dispatch(hardDeleteCompletedAction.error({ ...error, ...actionPayload }));
}

// It's called hardDelete, but it can execute SoftDelete depending of selected DeletedPersonas type.
// Depending of ExchangeAdmin settings for user account, SoftDelete might be unrecoverable for user,
// that's why it's inside HardDelete logic.
export const hardDelete = (payload: HardDeleteActionPayload) => (dispatch: ThunkDispatch) => {
    const contactIds = payload.personas.map(persona => persona.hubPersonaId);
    const deleteOperationType: DeleteOperationType =
        payload.personas[0].deletedType === DeletedPersonType.DeletedItem
            ? 'SoftDelete'
            : 'HardDelete';
    softOrHardDeleteOperation(contactIds, deleteOperationType).then(
        response => {
            dispatch(hardDeleteCompletedAction.success(payload));
            dispatch(refreshCurrentPersonaListData);
        },
        (error: Error) => {
            handleHardDeleteError(dispatch, Error('Error during delete operation'), payload);
            dispatch(refreshCurrentPersonaListData);
        }
    );
};
export type { DataActionFactory } from '../../../shared';
